// src/data/staticContentConfig.js

import {
  SparklesIcon,
  RectangleStackIcon,
  TagIcon,
  WrenchScrewdriverIcon,
  CloudIcon,
  GlobeAltIcon
} from '@heroicons/react/24/solid';

export const rawStaticContentConfig = [
  {
    category: {
      en: "Breathing",
      es: "Respiración",
    },
    items: [
      {
        key: 'wimhof-breathing',
        title: {
          en: 'Wim Hof Breathing',
          es: 'Respiración Wim Hof',
        },
        path: '/user/wim-hof-breathing',
        Icon: CloudIcon,
        color: 'text-blue-400',
        description: {
          en: 'Use the Wim Hof Method breathing technique to boost your energy, reduce stress, and enhance your immune system.',
          es: 'Utiliza la técnica de respiración del Método Wim Hof para aumentar tu energía, reducir el estrés y fortalecer tu sistema inmunológico.',
        },
      },
      {
        key: 'going-gamma-breathing',
        title: {
          en: 'Going Gamma Breathing',
          es: 'Respiración Hacia Gamma',
        },
        path: '/bashar/going-gamma-breathing',
        Icon: CloudIcon,
        color: 'text-purple-400',
        description: {
          en: 'A breathing exercise to elevate your brainwave state to gamma, associated with heightened perception and consciousness.',
          es: 'Un ejercicio de respiración para elevar tus ondas cerebrales al estado gamma, asociado con una percepción y consciencia elevadas.',
        },
      },
    ],
  },
  {
    category: {
      en: "Meditations",
      es: "Meditaciones",
    },
    items: [
      {
        key: 'healing-meditations',
        title: {
          en: 'Healing Meditations',
          es: 'Meditaciones de Sanación',
        },
        path: '/user/healing-meditations',
        Icon: SparklesIcon,
        color: 'text-purple-400',
        description: {
          en: 'Access your collection of healing and guided meditations for deep transformation.',
          es: 'Accede a tu colección de meditaciones guiadas y de sanación para una transformación profunda.',
        },
      },
      {
        key: '7-phase-meditation',
        title: {
          en: 'Seven Phase Meditation',
          es: 'Meditación de Siete Fases',
        },
        path: '/user/7-phase-meditation',
        Icon: SparklesIcon,
        color: 'text-purple-400',
        description: {
          en: 'Experience the renowned Seven Phase Meditation for spiritual growth and inner peace.',
          es: 'Experimenta la reconocida Meditación de Siete Fases para el crecimiento espiritual y la paz interior.',
        },
      },
    ],
  },
  {
    category: {
      en: "Tools",
      es: "Herramientas",
    },
    items: [
      {
        key: 'bashar-tools',
        title: {
          en: 'Bashar Tools',
          es: 'Herramientas de Bashar',
        },
        path: '/bashar/tools',
        Icon: WrenchScrewdriverIcon,
        color: 'text-indigo-400',
        description: {
          en: 'Explore practical tools and resources channeled by Bashar to enhance your daily life.',
          es: 'Explora herramientas prácticas y recursos canalizados por Bashar para enriquecer tu vida diaria.',
        },
      },
    ],
  },
  {
    category: {
      en: "Decks",
      es: "Barajas",
    },
    items: [
      {
        key: 'sacred-circuitry-oracle',
        title: {
          en: 'Sacred Circuitry Oracle',
          es: 'Oráculo de Circuitos Sagrados',
        },
        path: '/sacred-circuitry-oracle',
        Icon: RectangleStackIcon,
        color: 'text-indigo-400',
        description: {
          en: 'Consult the oracle deck for daily guidance, insights, and cosmic wisdom.',
          es: 'Consulta el oráculo para obtener guía diaria, claridad y sabiduría cósmica.',
        },
      },
      {
        key: 'portal-oracle-actual-state-reading',
        title: {
          en: 'Metaphysical Oracle',
          es: 'Oráculo Metafísico',
        },
        // Ruta dinámica según el idioma
        path: (lang) => `/${lang}`,
        Icon: RectangleStackIcon,
        color: 'text-indigo-400',
        description: {
          en: 'Consult the oracle deck for knowing your current state on a particular issue and receiving guidance.',
          es: 'Consulta el oráculo para conocer tu estado actual sobre una situación y recibir orientación.',
        },
      },
    ],
  },
  {
    category: {
      en: "General",
      es: "General",
    },
    items: [
      {
        key: 'my-full-transmissions',
        title: {
          en: 'My Full Transmissions',
          es: 'Mis Transmisiones Completas',
        },
        path: '/user/transmissions',
        Icon: TagIcon,
        color: 'text-yellow-500',
        description: {
          en: 'Browse your complete library of all purchased video and audio transmissions.',
          es: 'Explora tu biblioteca completa de todas las transmisiones de video y audio adquiridas.',
        },
      },
      {
        key: 'more-from-bashar',
        title: {
          en: 'More From Bashar',
          es: 'Más de Bashar',
        },
        path: '/bashar/selector',
        Icon: GlobeAltIcon,
        color: 'text-yellow-500',
        description: {
          en: 'Discover and explore a wider range of channels and content from Bashar.',
          es: 'Descubre y explora una variedad más amplia de canalizaciones y contenidos de Bashar.',
        },
      },
    ],
  },
];

/**
 * Función que retorna el menú estático traducido según el idioma dado ('es' o 'en').
 */
export const getStaticContentConfig = (lang = 'en') => {
  const currentLang = lang === 'es' ? 'es' : 'en';

  return rawStaticContentConfig.map((categoryObj) => ({
    category: categoryObj.category[currentLang] || categoryObj.category.en,
    items: categoryObj.items.map((item) => ({
      ...item,
      title: item.title[currentLang] || item.title.en,
      description: item.description[currentLang] || item.description.en,
      path: typeof item.path === 'function' ? item.path(currentLang) : item.path,
    })),
  }));
};

// Mantiene compatibilidad hacia atrás si otro componente importa staticContentConfig directamente
export const staticContentConfig = getStaticContentConfig('en');